import React from "react";
import styles from "./AlumniTopHeader.module.scss";
import Buttons from "../../Atoms/Buttons/Buttons";
import SearchInput from "../../Atoms/Inputs/SearchInput";
import uploadBulk from "../../../assets/Imagess/upload-bulk.svg";

const AlumniTopHeader = ({
  search,
  setSearch,
  handleNewClick,
  style,
  buttonTitle,
  icon,
  selected,
}) => {
  return (
    <div className={styles["icon-container"]} style={{ ...style }}>
      <div>
        {"batch" !== selected && (
          <SearchInput search={search} setSearch={setSearch} />
        )}
      </div>
      <div className={styles["icon-subcontainer"]}>
        {"students" === selected && (
          <div className={styles["upload-bulk-container"]}>
            <img src={uploadBulk} />
            <p className={styles["upload-bulk-text"]}>Upload Bulk</p>
          </div>
        )}
        {"events" !== selected && (
          <Buttons
            text={buttonTitle}
            icon={icon}
            rounded={true}
            color="rgba(13, 160, 110, 1)"
            handleOnClick={handleNewClick}
            type="submit"
          />
        )}
      </div>
    </div>
  );
};

export default AlumniTopHeader;
